import { SystemListValuesModel } from "@dana/Types/ApiModels";
import { get } from "@insite/client-framework/Services/ApiService";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";

const apiUri = "/api/v2/dana/standardReturnDetails";

export interface ShipmentDetails {
  carrierName: string;
  dateShipped?: string; // ISO date string
  quantityShipped: number;
  tracking: string;
}
export interface SalseOrgDetails {
  orgName: string;
  orgAddress: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  siteName: string;
}
// Define an interface for the response model
export interface RmaAdditionalDetails {
  disposition: string | null;
  reason: string | null;
  emailContacts: string | null;
  internalRefNumber: string | null;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  email: string | null;
  customerName: string | null;
  country: string | null;
  zipCode: string | null;
  state: string | null;
  city: string | null;
  address1: string | null;
  address2: string | null;
  freightHandling: string | null;
  carrier: string | null;
  carrierAccountNo: string | null;
  shippingInstructions: string | null;
  originalOrderNumber: string | null;
}
export interface OrderInfo {
  baseprice: number;
  branch: string;
  currency: string;
  customerItemNumber: string;
  discount: number;
  extendedAmount: number;
  frCode: string;
  identifier: string;
  invoiceDate?: string; // ISO date string
  invoiceNumber: string;
  lastStatus: string;
  lineNumber: string;
  lineType: string;
  netAmount: number;
  nextStatusDescription: string;
  orderType: string;
  partDescription: string;
  partDescription2: string;
  partNumber: string;
  pickNumber: string;
  pricePerUnit: number;
  quantityOrdered: number;
  quantityShipped: number;
  rejectionCode: string;
  rejectionDescription: string;
  rejectionStatusIndicator: string;
  requestDate?: string; // ISO date string
  restockingFees: number;
  shipmentDetails: ShipmentDetails[];
  tariff: number;
  weight: number;
  weightUnit: string;
  countryofOrigin: string;
  hsCode: string;
}

export interface StandardReturnOrderDetails {
  accountNumber: string;
  billAddress1: string;
  billAddress2: string;
  billCity: string;
  billCountry: string;
  billName: string;
  billState: string;
  billTo: string;
  billZipcode: string;
  carrierName: string;
  carrierNumber: string;
  currency: string;
  danaShipmentNumber: string;
  dealerCode: string;
  deliveryStatusIndicator: string;
  documentDate?: string; // ISO date string
  documentNumber: string;
  mailAddress1: string;
  mailAddress2: string;
  mailCity: string;
  mailCountry: string;
  mailName: string;
  mailState: string;
  mailTo: string;
  mailZipcode: string;
  orderInfo: OrderInfo[];
  orderType: string;
  poNumber: string;
  processNumber: string;
  rejectionStatusIndicator: string;
  secondaryPo: string;
  shipAddress1: string;
  shipAddress2: string;
  shipCity: string;
  shipCountry: string;
  shipName: string;
  shipState: string;
  shipTo: string;
  shipZipcode: string;
  termsDescription: string;
  termsNumber: string;
  firstName: string;
  lastName: string;
  userName: string;
  userEmail: string;
  userId: string;

}
export interface StandardReturnDetailsResult {
  logo: string,
  salseOrgDetails: SalseOrgDetails,
  rmaAdditionalDetails: RmaAdditionalDetails,
  standardReturnOrderDetails: StandardReturnOrderDetails,
  dispositionPreferences?: SystemListValuesModel[]
}

export async function getStandardReturnDetails(parameter: GetOrderApiParameter) {
  const { orderNumber, ...newParameter } = parameter;
  const standardReturnHistoryResult = await get<StandardReturnDetailsResult>(`${apiUri}/${orderNumber}`, newParameter);
  return standardReturnHistoryResult;
}
